module.exports = __webpack_public_path__ + "img/arrow_back.5b30e0ec.svg";